<template>
  <div class="card">
    <div class="card-body p-3">
      <shimmer
        v-if="imageHead"
        :height="imageHeadHeight"
        width="100%"
        class="text-center mb-2"
        :rounded="true"
      ></shimmer>
      <paragraph-shimmer :withTitle="withTitle" :justified="justified" />
    </div>
  </div>
</template>
<script>
import shimmer from '@/components/shimmers/shimmer'
import paragraphShimmer from '@/components/shimmers/paragraph'

export default {
  components: {
    shimmer,
    paragraphShimmer
  },
  props: {
    withTitle: {
      default: true,
      type: Boolean
    },
    justified: {
      default: false,
      type: Boolean
    },
    imageHead: {
      default: true,
      type: Boolean
    },
    imageHeadHeight: {
      default: '300px',
      type: String
    }
  }
}
</script>
